<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <div class="row">
        <h5  class="modal-title container" i18n>Registro de Medição</h5>
      </div>
      <button type="button" (click)="onClose()" class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
              aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="modal-body" *ngIf="!loading">
      <div class="row mb-3">
        <div class="col-12 col-md-4">
          <app-input type="text" [isLabel]="true" i18n-label="@@Registro" label="N° do Registro de Medição "></app-input>
          RM{{appraisal?.experimentCode}}
        </div>
        <div class="col-12 col-md-4">
          <app-input type="text" [isLabel]="true" i18n-label="@@codigo" label="Código de Ensaio "></app-input>
          CE{{appraisal?.experimentCode}}
        </div>
        <div class="col-12 col-md-4">
          <app-input type="text" [isLabel]="true" i18n-label="@@ensaio" label="Data do Ensaio"></app-input>
          {{ appraisal?.experimentDate | moment: 'L' }}
        </div>
      </div>
      <br>
      <section>
          <div id="equipment">
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between" style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;" (click)="unfoldMoreOrLessEquipment()">
                  <h5 class="mb-3" i18n><strong>Equipamento</strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button" class="btn text-secondary btn-icon-block"
                          (click)="unfoldMoreOrLessEquipment()">
                    <i class="material-icons"
                       *ngIf="typeUnfoldEquipment === 'less'; else elseBlockTable1">unfold_less</i>
                    <ng-template #elseBlockTable1>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldEquipment === 'more'" class="limited-height">
                <div class="card card-body">
                  <div class="form-group">
                    <div class="row mb-3">
                      <div class="col-12 col-md-3">
                        <app-input type="text" [isLabel]="true" i18n-label="@@serie" label="N° de Série"></app-input>
                        {{equipment?.serialNumber}}
                      </div>
                      <div class="col-12 col-md-3">
                        <app-input type="text" [isLabel]="true" i18n-label="@@fabricante" label="Fabricante"></app-input>
                        {{manufacturer?.name}}
                      </div>
                      <div class="col-12 col-md-3">
                        <app-input type="text" [isLabel]="true" i18n-label="@@" label="Modelo"></app-input>
                        {{equipmentModel?.name}}
                      </div>
                      <div class="col-12 col-md-3">
                        <app-input type="text" [isLabel]="true" i18n-label="@@" label="Instrumento"></app-input>
                        {{equipmentModel?.instrument}}
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12 col-md-6">
                        <app-input type="text" [isLabel]="true" i18n-label="@@" label="Lacres Principais"></app-input>
                        {{appraisal?.equipment.mainSeals}}
                      </div>
                      <div class="col-12 col-md-6">
                        <app-input type="text" [isLabel]="true" i18n-label="@@" label="Lacres Secundários"></app-input>
                        {{appraisal?.equipment.secondarySeals}}
                      </div>
                    </div>
                    <fieldset *ngIf="equipmentModel?.category === 'noIntrusive'">
                      <legend i18n>Sensor</legend>
                      <div class="row mb-3">
                        <div class="col-12 col-md-6">
                          <app-input type="text" [isLabel]="true" i18n-label="@@" label="N° de Série"></app-input>
                          {{equipment?.additionalSerialNumber}}
                        </div>
                        <div class="col-12 col-md-6">
                          <app-input type="text" [isLabel]="true" i18n-label="@@" label="Lacre Principais"></app-input>
                          {{appraisal?.equipment.additionalMainSeals}}
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      <br>
      <div class="row mb-3">
        <div class="col-12 col-md-12">
          <app-input type="text" [isLabel]="true" i18n-label="@@" label="N° de Portaria de Aprovação"></app-input>
          {{appraisal?.ordinanceApproveNumber}}
        </div>
      </div>
      <br>
      <section>
          <div id="local">
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between" style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;" (click)="unfoldMoreOrLessLocal()">
                  <h5 class="mb-3" i18n><strong>Local</strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button" class="btn text-secondary btn-icon-block"
                          (click)="unfoldMoreOrLessLocal()">
                    <i class="material-icons"
                       *ngIf="typeUnfoldLocal === 'less'; else elseBlockTable1">unfold_less</i>
                    <ng-template #elseBlockTable1>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldLocal === 'more'" class="limited-height">
                <div class="card card-body">
                  <div class="form-group">
                    <div class="row mb-3">
                      <div class="col-12 col-md-6">
                        <app-input type="text" [isLabel]="true" i18n-label="@@" label="Ponto"></app-input>
                        {{spot?.code}} - {{spot?.description}}
                      </div>
                      <div class="col-12 col-md-6">
                        <app-input type="text" [isLabel]="true" i18n-label="@@" label="Faixa"></app-input>
                        {{lane?.code}} - {{lane?.number}}
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12 col-md-3">
                        <app-input type="text" [isLabel]="true" i18n-label="@@" label="Descrição"></app-input>
                        {{lane?.name}}
                      </div>
                      <div class="col-12 col-md-3">
                        <app-input type="text" [isLabel]="true" i18n-label="@@" label="Sentido"></app-input>
                        {{lane?.direction}}
                      </div>
                      <div class="col-12 col-md-3">
                        <app-input type="text" [isLabel]="true" i18n-label="@@" label="Velocidade da Via"></app-input>
                        {{lane?.speeds?.regularVehicles}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="responsible">
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between" style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;" (click)="unfoldMoreOrLessResponsible()">
                  <h5 class="mb-3" i18n><strong>Responsável</strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button" class="btn text-secondary btn-icon-block"
                          (click)="unfoldMoreOrLessResponsible()">
                    <i class="material-icons"
                       *ngIf="typeUnfoldResponsible === 'less'; else elseBlockTable1">unfold_less</i>
                    <ng-template #elseBlockTable1>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldResponsible === 'more'" class="limited-height">
                <div class="card card-body">
                  <div class="form-group">
                    <div class="card card-body">
                      <div class="form-group">
                        <div class="row mb-3">
                          <div class="col-12 col-md-6">
                            <app-input type="text" [isLabel]="true" i18n-label="@@" label="Executor dos Ensaios"></app-input>
                            {{ user?.name }}
                          </div>
                          <div class="col-12 col-md-6">
                            <app-input type="text" [isLabel]="true" i18n-label="@@" label="Data da Verificação"></app-input>
                            {{ appraisal?.experimentDate | moment: 'L' }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      <br>
      <form [formGroup]="appMeasurementsForm" (submit)="onSubmit()">
        <div class="row mb-3">
            <div class="col-12 col-md-6">
              <label i18n>Modelo Conforme Caderno de Componentes: <small class="text-danger">*</small></label>
              <br>
              <div class="form-group">
                <mat-radio-group formControlName="modelAccordingToComponentBook" required="true">
                  <mat-radio-button i18n color="primary" style="margin-right: 3rem;"
                    [value]="true">Sim</mat-radio-button>
                  <mat-radio-button i18n color="primary" style="margin-right: 3rem;"
                    [value]="false">Não</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <label i18n>Modelo Conforme Portaria de Aprovação e Aditivos : <small class="text-danger">*</small></label>
              <br>
              <div class="form-group">
                <mat-radio-group formControlName="modelAccordingToApprovalOrder" required="true">
                  <mat-radio-button i18n color="primary" style="margin-right: 3rem;"
                    [value]="true">Sim</mat-radio-button>
                  <mat-radio-button i18n color="primary" style="margin-right: 3rem;"
                    [value]="false">Não</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        <div class="row mb-3">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <app-input i18n-label="@@padrao" type="text" inputRequired=true formControlName="measurementStandard" label="Padrão de Medição">
                </app-input>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <app-input i18n-label="@@certificado" type="text" inputRequired=true formControlName="calibrationLicence" label="Certificação de Aferição">
                </app-input>
              </div>
            </div>
          </div>
        <fieldset>
          <legend class="text-lg-left" i18n>Ensaio de Campo <small class="text-danger">*</small></legend>
          <table class="table bg-white">
            <thead class="bg-header-table">
              <tr>
                <th i18n>Medições</th>
                <th i18n class="">Velocidade do Padrão (P)KM/H</th>
                <th i18n class="">Velocidade do Registrada (R)KM/H</th>
                <th i18n class="text-center">E1=R-P</th>
                <th i18n class="text-center">E1 Máximo Admissível</th>
                <th i18n class="text-center">Situação</th>
                <th i18n class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let appMeasurement of appMeasurementsForm.get('measurements')['controls']; let i = index">
                <td>
                  <div [formGroup]="appMeasurement">
                    {{i+1}}
                  </div>
                </td>
                <td>
                  <div [formGroup]="appMeasurement">
                    <app-input i18n-label="@@speed" (change)="calculateResult(i)" type="number" formControlName="standardSpeed">
                    </app-input>
                  </div>
                </td>
                <td>
                  <div [formGroup]="appMeasurement">
                    <app-input i18n-label="@@recordedSpeed" (change)="calculateResult(i)" type="number" formControlName="recordedSpeed">
                    </app-input>
                  </div>
                </td>
                <td>
                  <div [formGroup]="appMeasurement">
                    <app-input i18n-label="@@result" type="number" formControlName="result" [inputDisabled]="true">
                    </app-input>
                  </div>
                </td>
                <td>
                  <div [formGroup]="appMeasurement">
                    {{getFormula(i)}}
                  </div>
                </td>
                <td>
                  <div [formGroup]="appMeasurement">
                    <span *ngIf="getLabel(i) === 'approved'" class="btn btn-success btn-sm mt-2" i18n>
                       Aprovado
                    </span>
                    <span *ngIf="getLabel(i) === 'failed'" class="btn btn-danger btn-sm mt-2" i18n>
                       Reprovado
                    </span>
                    <span *ngIf="getLabel(i) === ''" class="btn btn-secondary btn-sm mt-2" i18n>
                       Pendente
                    </span>
                  </div>
                </td>
                <td>
                  <div [formGroup]="">
                    <span [routerLink]="" (click)="removeMeasurements(i)"
                          class="btn text-danger btn-icon-block" data-placement="top" i18n-appTooltip
                          appTooltip="Apagar registro">
                      <i class="material-icons">remove_circle</i>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="7" class="text-center">
                    <span *ngIf="sizeMeasurements === 10 && situationEnd === 'approved' && isValid" class="btn btn-success btn-max mt-2" i18n>
                       Aprovado
                    </span>
                    <span *ngIf="sizeMeasurements === 10 && situationEnd === 'failed' && isValid" class="btn btn-danger btn-max mt-2" i18n>
                       Reprovado
                    </span>
                </td>
              </tr>
            </tbody>
           </table>
          <div class="row">
            <div class="col-11">
              <button *ngIf="sizeMeasurements < 10" type="button" class="btn btn-fade-info mt-3" (click)="addMeasurements()">
                Adicionar Novo
              </button>
            </div>
            <div class="col-1 text-right">
              <p class="mt-3">{{sizeMeasurements}}/10</p>
            </div>
          </div>

          </fieldset>
      </form>
    </div>
    <div class="loading-page" *ngIf="loading">
      <div class="loading-spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" (click)="onCancel()">
        <app-loading [promise]="promise" text="Cancelar" i18n-text></app-loading>
      </button>
      <button class="btn btn-primary" (click)="onSubmit()" [ngClass]="{disabled: !isValid}">
        <app-loading [promise]="promise" text="Confirmar" i18n-text></app-loading>
      </button>
    </div>
  </div>
</div>
